import { render, staticRenderFns } from "./StakeRadioSelect.vue?vue&type=template&id=2d43b16e&"
import script from "./StakeRadioSelect.vue?vue&type=script&setup=true&lang=js&"
export * from "./StakeRadioSelect.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports